import { render } from "./nuovaRicevutaModal.vue?vue&type=template&id=54d6ebbe&scoped=true&ts=true"
import script from "./nuovaRicevutaModal.vue?vue&type=script&lang=ts"
export * from "./nuovaRicevutaModal.vue?vue&type=script&lang=ts"

import "./nuovaRicevutaModal.vue?vue&type=style&index=0&id=54d6ebbe&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d6ebbe"]])

export default __exports__